























import { defineComponent, ref } from '@vue/composition-api'

import HLine from '@/components/atoms/HLine.vue'
import ItemHierarchyGroup from '@/components/organisms/h/item/hierarchy/ItemHierarchyGroup.vue'
import ExtractConditionLayout from '@/components/organisms/h/layout/ExtractConditionLayout.vue'
import {
  WeeklyDailyBudgetConfExtractCondition,
  itemHierarchyGroupExtractCondition,
  itemHierarchyUseList,
} from '@/types/entities'
import { addDayYMD } from '@/utils/mixin'

export default defineComponent({
  components: {
    ExtractConditionLayout,
    ItemHierarchyGroup,
    HLine,
  },
  setup(_, context) {
    const storeUseList = ref<itemHierarchyUseList>([['StoreShelve', 'Store']])
    // 当日時点で営業中、または1週間以内に開店する店舗を表示する
    const storeValidData = [addDayYMD(0), addDayYMD(7)]
    const itemStoreUseList = ref<itemHierarchyUseList>([['Chubunrui','Shobunrui', 'Class']])
    const extractConditionOfStore = ref<itemHierarchyGroupExtractCondition>({})
    const extractConditionOfItemStore = ref<itemHierarchyGroupExtractCondition>({})

    const changeExtractCondition = () => {
      const cond: WeeklyDailyBudgetConfExtractCondition = {
        storeShelve: extractConditionOfStore.value.storeShelve || [],
        storeShelveCount: extractConditionOfStore.value.storeShelveCount || 0,
        store: extractConditionOfStore.value.store || [],
        storeCount: extractConditionOfStore.value.storeCount || 0,
        itemStore: {
          chubunrui: extractConditionOfItemStore.value.chubunrui || [],
          chubunruiCount: extractConditionOfItemStore.value.chubunruiCount || 0,
          shobunrui: extractConditionOfItemStore.value.shobunrui || [],
          shobunruiCount: extractConditionOfItemStore.value.shobunruiCount || 0,
          class: extractConditionOfItemStore.value.class || [],
          classCount: extractConditionOfItemStore.value.classCount || 0,
        },
      }
      context.emit('change-extract-condition', cond)
    }

    const changeExtractConditionOfItemStore = (
      params: itemHierarchyGroupExtractCondition
    ) => {
      extractConditionOfItemStore.value = params
      changeExtractCondition()
    }
    const changeExtractConditionOfStore = (
      params: itemHierarchyGroupExtractCondition
    ) => {
      extractConditionOfStore.value = params
      changeExtractCondition()
    }

    const requiredItemInput = [
      '中分類：常に入力',
      '店舗エリア・店舗・小分類・クラスは任意の絞り込み',
    ]
    return {
      requiredItemInput,
      storeUseList,
      storeValidData,
      itemStoreUseList,
      changeExtractConditionOfStore,
      changeExtractConditionOfItemStore,
    }
  },
})
